"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AUDIT_ADDON_TAG = exports.PREVIEW_ADDON_TAG = void 0;
exports.PREVIEW_ADDON_TAG = '_pre';
exports.AUDIT_ADDON_TAG = '_audit';
//# sourceMappingURL=env.js.map